import Logo from "./../../Images/logo.jpg";
import QuestionMarkIcon from "./../../Images/question-mark.png";

const HeaderMobileTrial = ({ setHelpModalActive, setHelpModalContent }) => {
  const handleHelpModal = () => {
    setHelpModalActive(true);
    setHelpModalContent("1.0");
  };

  return (
    <div className="container-header-mobile">
      <img className="header-logo-mobile" src={Logo} alt="logo" />
      <div className="container-header-icons-mobile">
        <img
          className="header-icons-mobile"
          src={QuestionMarkIcon}
          alt="question mark icon"
          onClick={handleHelpModal}
        />
      </div>
    </div>
  );
};
export default HeaderMobileTrial;
